import { render, staticRenderFns } from "./editMealbrand.vue?vue&type=template&id=17f95546&scoped=true"
import script from "./editMealbrand.vue?vue&type=script&lang=js"
export * from "./editMealbrand.vue?vue&type=script&lang=js"
import style0 from "./editMealbrand.vue?vue&type=style&index=0&id=17f95546&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f95546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f95546')) {
      api.createRecord('17f95546', component.options)
    } else {
      api.reload('17f95546', component.options)
    }
    module.hot.accept("./editMealbrand.vue?vue&type=template&id=17f95546&scoped=true", function () {
      api.rerender('17f95546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mealOrder/mealView/mealBrand/editMealbrand.vue"
export default component.exports